import { render, staticRenderFns } from "./FlapsAccountQueryForm.vue?vue&type=template&id=4c925a1e&scoped=true&"
import script from "./FlapsAccountQueryForm.vue?vue&type=script&lang=js&"
export * from "./FlapsAccountQueryForm.vue?vue&type=script&lang=js&"
import style0 from "./FlapsAccountQueryForm.vue?vue&type=style&index=0&id=4c925a1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c925a1e",
  null
  
)

export default component.exports